import React from 'react'
import {UniLink} from '../unilink/index'
import './contentSelect.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'


//t = current time
//b = start value
//c = change in value
//d = duration
Math.easeInOutQuad = function (t, b, c, d) {
  t /= d/2
  if (t < 1) return c/2*t*t + b
  t--
  return -c/2 * (t*(t-2) - 1) + b
}
/*function getInnerWidth(element) {

  let wrapper = document.createElement('span'),
    result

  while (element.firstChild) {
    wrapper.appendChild(element.firstChild)
  }

  element.appendChild(wrapper)

  result = wrapper.offsetWidth

  element.removeChild(wrapper)

  while (wrapper.firstChild) {
    element.appendChild(wrapper.firstChild)
  }

  return result

}*/

class ContentSelect extends React.PureComponent {
  container = null;
  circles = {}
  idToIndex = {}
  duration = 600;
  constructor(props) {
    super(props)
    this.state = {
      scrollOffset: 0,
      activeIndex: 0,
    }

    this.resize = this.resize.bind(this)
    this.scrollTo = this.scrollTo.bind(this)
    this.goLeft = this.goLeft.bind(this)
    this.goRight = this.goRight.bind(this)

    for (let i in props.content) {
      this.idToIndex[props.content[i].id] = parseInt(i)
    }
  }

  componentDidMount() {
    for (let i in this.props.content) {
      this.idToIndex[this.props.content[i].id] = parseInt(i)
    }
    window.addEventListener('resize', this.resize, false)
    this.setState({
      scrollOffset: this.container.offsetWidth/2
    })
    const {scrollOffset} = this.state
    const {activeId} = this.props
    if (activeId in this.circles && this.circles[activeId]) {
      const pos = this.circles[activeId].offsetLeft
      this.scrollTo(pos - scrollOffset, this.duration)
      const activeIndex = this.idToIndex[activeId]
      this.setState({
        activeIndex
      })
    }
  }
  componentDidUpdate() {
    const {scrollOffset} = this.state
    const {activeId} = this.props
    if (activeId in this.circles && this.circles[activeId]) {
      const pos = this.circles[activeId].offsetLeft
      this.scrollTo(pos - scrollOffset, this.duration)
      const activeIndex = this.idToIndex[activeId]
      this.setState({
        activeIndex
      })
    }
    for (let i in this.props.content) {
      this.idToIndex[this.props.content[i].id] = parseInt(i)
    }
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.resize, false)
  }
  resize() {
    const getScrollOffset = () => {
      if (this.container) {
        this.setState({
          scrollOffset: this.container.offsetWidth/2
        })
      }
      requestAnimationFrame(getScrollOffset)
    }
    requestAnimationFrame(getScrollOffset)
  }

  scrollTo(to, duration) {
    let start = this.container.scrollLeft,
      change = to - start,
      currentTime = Date.now()

    let animateScroll = () => {
      const millis = Date.now() - currentTime
      const val = Math.easeInOutQuad(millis, start, change, duration)
      if (this.container) {
        this.container.scrollLeft = val
      }
      if (millis < duration) {
        window.requestAnimationFrame(animateScroll)
      }
    }
    window.requestAnimationFrame(animateScroll)
  }
  goLeft() {
    const {activeIndex} = this.state
    const {chooseActiveFromId, content} = this.props
    if (activeIndex !== 0) {
      const newId = content[activeIndex-1].id
      chooseActiveFromId(newId)
    }
  }
  goRight() {
    const {activeIndex} = this.state
    const {chooseActiveFromId, content} = this.props
    if (activeIndex !== content.length-1) {
      const newId = content[activeIndex+1].id
      chooseActiveFromId(newId)
    }
  }
  render() {
    const {className, content, activeId, chooseActiveFromId, noArrows, colorSubject, dark, toggleVote} = this.props
    const {activeIndex} = this.state
    const contentSelectclassNames = ['content-select',className]

    const getCircleClassName = (c) => {
      let circleClassName = activeId === c.id ? 'content-select__circle content-select__circle--active' : 'content-select__circle'
      if (colorSubject) {
        if (dark) {
          circleClassName = activeId === c.id ? `content-select__circle content-select__circle-${colorSubject}--dark content-select__circle-${colorSubject}--dark--active` : `content-select__circle content-select__circle-${colorSubject}--dark`
        } else {
          circleClassName = activeId === c.id ? `content-select__circle content-select__circle-${colorSubject} content-select__circle-${colorSubject}--active` : `content-select__circle content-select__circle-${colorSubject}`
        }

      }
      return circleClassName
    }
    
    const arrowClassNames = colorSubject ? ['content-select__arrow', `content-select__arrow--${colorSubject}`] : ['content-select__arrow']

    const arrows = []
    if (activeIndex > 0) {
      arrows.push(
        <UniLink
          key='left'
          onClick={this.goLeft}
          className={`${arrowClassNames.join(' ')} content-select__arrow--left`}>
          <FontAwesomeIcon icon={['fa', 'angle-left']} />
        </UniLink>
      )
    }
    if (activeIndex < content.length-1) {
      arrows.push(
        <UniLink
          key='right'
          onClick={this.goRight}
          className={`${arrowClassNames.join(' ')} content-select__arrow--right`}>
          <FontAwesomeIcon icon={['fa', 'angle-right']} />
        </UniLink>
      )
    }

    return (
      <div className={contentSelectclassNames.join(' ')}>
        {
          noArrows
            ? null
            : arrows
        }
        <div
          ref={node => this.container = node}
          className={colorSubject ? `content-select__container content-select__container--${colorSubject}` : `content-select__container`}>
          {
            content.map((c, index)=>{
              const {type, id, currentUserHasVoted, voteCount, slug} = c
              const voteCountClassNames = ['content-select__votecount']
              if (toggleVote) {
                voteCountClassNames.push('content-select__votecount--clickable')
              }
              if (colorSubject && dark) {
                voteCountClassNames.push(`content-select__votecount--${colorSubject}`)
              }
              if (currentUserHasVoted) {
                voteCountClassNames.push('content-select__votecount--voted')
                if (colorSubject && dark) {
                  voteCountClassNames.push(`content-select__votecount--${colorSubject}--voted`)
                }
              }
              return (
                <div
                  className={'content-select__circle-container'}
                  ref={node => this.circles[id] = node}
                  key={id}>
                  <UniLink
                    href={slug}
                    onClick={(e)=>{
                      this.setState({
                        activeIndex: this.idToIndex[id]
                      })
                      chooseActiveFromId(id)
                    }}
                    className={getCircleClassName(c)}>
                    {(c.contentType === 'video') ? <FontAwesomeIcon icon={['fa', 'video']} /> : <FontAwesomeIcon icon={['fa', 'quote-left']} />}
                  </UniLink>
                  <span
                    onClick={()=>toggleVote(type, id)}
                    className={voteCountClassNames.join(' ')}>
                    { currentUserHasVoted ? <FontAwesomeIcon icon={['fa', 'heart']} className='content-select__votecount-heart' /> : <FontAwesomeIcon icon={['far', 'heart']} className='content-select__votecount-heart' /> }   {voteCount}
                  </span>
                </div>
              )
            })
          }
        </div>
      </div>
    )
  }
}

export default ContentSelect



// WEBPACK FOOTER //
// ./src/core/components/content-select/ContentSelect.js